export function getCookie(name: string): string | null {
    if (!document.cookie) return null
    const cookies = document.cookie.split(';')
    for (const raw of cookies) {
        const cookie = raw.trim()
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1))
        }
    }
    return null
}
